import React, { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Button, Select, TextInput } from 'components/Form'
import { createApiRecord, updateApiRecord } from 'services/CompanyAdminService'
import { useDispatch, useSelector } from 'react-redux'
import { getRecord } from './store/dataSlice'
import reducer from './store'
import { injectReducer } from 'store'
import { Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import { Success } from 'utils/alerts'
import { titleOptions } from 'utils/options'
injectReducer('companyAdmin', reducer)

const validationSchema = Yup.object().shape({
    company_id: Yup.number().required('Please select company'),
    title: Yup.string().required('Title Required'),
    first_name: Yup.string().required('First Name Required'),
    last_name: Yup.string().required('Last Name Required'),
    email: Yup.string().required('Email is required').email('Email is invalid'),
})

const Create = () => {
    const { id } = useParams()
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const { companyData } = useSelector((state) => state.listData)
    const { view, record, loading } = useSelector(
        (state) => state.companyAdmin.data,
    )

    useEffect(() => {
        if (id) {
            fetchData(id)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id])

    const fetchData = (id) => dispatch(getRecord(id))

    const handleDiscard = () => navigate('/company-management/company-admin')

    const handleSubmit = (values, setSubmitting) => {
        const data = {
            title: values.title,
            user: {
                first_name: values.first_name,
                last_name: values.last_name,
                email: values.email,
                password: values.password,
            },
        }
        setSubmitting(true)
        if (id) {
            data.company = values.company_id
            updateApiRecord(id, data)
                .then(() => {
                    Success('Updated Successfully!')
                    handleDiscard()
                    // dispatch(getCompanyData())
                    setSubmitting(false)
                })
                .catch((error) => {
                    setSubmitting(false)
                    return error
                })
        } else {
            data.company_id = values.company_id
            createApiRecord(data)
                .then(() => {
                    Success('Created Successfully!')
                    handleDiscard()
                    // dispatch(getCompanyData())
                    setSubmitting(false)
                })
                .catch((error) => {
                    setSubmitting(false)
                    return error
                })
        }
    }

    if (loading) {
        return null
    }

    return (
        <>
            <div className="flex flex-col gap-1 mb-3 sm:flex-row sm:items-center sm:justify-between">
                <h2 className="font-semibold text-black text-title-md2 dark:text-white">
                    Company Admin
                </h2>
            </div>
            <div className="flex flex-col items-center">
                <div className="w-full xl:w-1/2 bg-white border rounded-lg border-stroke shadow-default dark:border-strokedark dark:bg-boxdark">
                    <div className="px-5 py-3 border-b border-stroke dark:border-strokedark">
                        <h3 className="font-medium text-black dark:text-white">
                            {id
                                ? 'Update Company Admin'
                                : 'Add New Company Admin'}
                        </h3>
                    </div>
                    <div className="flex flex-col gap-3 p-6">
                        <Formik
                            initialValues={id ? record : view}
                            validationSchema={validationSchema}
                            onSubmit={(values, { setSubmitting }) => {
                                handleSubmit(values, setSubmitting)
                            }}
                        >
                            {({ values, touched, errors, isSubmitting }) => (
                                <Form>
                                    <div className="grid grid-cols-1 gap-x-4 gap-y-4">
                                        <Field name="company_id">
                                            {({ field, form }) => (
                                                <Select
                                                    options={companyData}
                                                    label="Company"
                                                    size="sm"
                                                    placeholder="Select"
                                                    name="company_id"
                                                    className="md:col-span-2"
                                                    error={
                                                        errors.company_id &&
                                                        touched.company_id
                                                    }
                                                    message={errors.company_id}
                                                    value={values?.company_id}
                                                    onChange={(e) =>
                                                        form.setFieldValue(
                                                            field.name,
                                                            e.target.value,
                                                        )
                                                    }
                                                />
                                            )}
                                        </Field>
                                        <Field name="title">
                                            {({ field, form }) => (
                                                <Select
                                                    options={titleOptions}
                                                    label="Title"
                                                    size="sm"
                                                    placeholder="Select"
                                                    name="title"
                                                    className="md:col-span-2"
                                                    error={
                                                        errors.title &&
                                                        touched.title
                                                    }
                                                    message={errors.title}
                                                    value={values?.title}
                                                    onChange={(e) =>
                                                        form.setFieldValue(
                                                            field.name,
                                                            e.target.value,
                                                        )
                                                    }
                                                />
                                            )}
                                        </Field>
                                    </div>
                                    <div className="grid grid-cols-1 gap-x-4 gap-y-4 md:grid-cols-4 mt-4">
                                        <Field name="first_name">
                                            {({ field, form }) => (
                                                <TextInput
                                                    type="text"
                                                    className="md:col-span-2"
                                                    label="First Name"
                                                    name="first_name"
                                                    error={
                                                        errors.first_name &&
                                                        touched.first_name
                                                    }
                                                    message={errors.first_name}
                                                    value={values?.first_name}
                                                    onChange={(e) =>
                                                        form.setFieldValue(
                                                            field.name,
                                                            e.target.value,
                                                        )
                                                    }
                                                />
                                            )}
                                        </Field>
                                        <Field name="last_name">
                                            {({ field, form }) => (
                                                <TextInput
                                                    type="text"
                                                    className="md:col-span-2"
                                                    label="Last Name"
                                                    name="last_name"
                                                    error={
                                                        errors.last_name &&
                                                        touched.last_name
                                                    }
                                                    message={errors.last_name}
                                                    value={values?.last_name}
                                                    onChange={(e) =>
                                                        form.setFieldValue(
                                                            field.name,
                                                            e.target.value,
                                                        )
                                                    }
                                                />
                                            )}
                                        </Field>
                                        <Field name="email">
                                            {({ field, form }) => (
                                                <TextInput
                                                    type="text"
                                                    className="md:col-span-2"
                                                    label="Email"
                                                    name="email"
                                                    error={
                                                        errors.email &&
                                                        touched.email
                                                    }
                                                    message={errors.email}
                                                    value={values?.email}
                                                    onChange={(e) =>
                                                        form.setFieldValue(
                                                            field.name,
                                                            e.target.value,
                                                        )
                                                    }
                                                />
                                            )}
                                        </Field>
                                    </div>
                                    <div className="flex items-center justify-end gap-4 mt-3">
                                        <Button
                                            className="h-10 w-18 text-primary border border-primary dark:text-secondary dark:border-secondary"
                                            onClick={handleDiscard}
                                        >
                                            Discard
                                        </Button>
                                        <Button
                                            type="submit"
                                            className="flex items-center justify-center px-6 py-2 text-white transition border rounded-lg cursor-pointer hover:bg-opacity-90 border-primary bg-primary dark:border-secondary dark:bg-secondary"
                                            disabled={isSubmitting}
                                        >
                                            Save
                                        </Button>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Create
